import { Component, OnInit, Input, ViewChild, Output, EventEmitter, ChangeDetectorRef } from '@angular/core';
import { Document } from 'src/app/_models/document';
import { MatTableDataSource } from '@angular/material/table';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { SelectionModel } from '@angular/cdk/collections';
import { DocumentService } from 'src/app/_services/document.services';
import { Category, User } from 'src/app/_models';
import { AuthenticationService } from 'src/app/_services/authentication.service';
import { MatDialog } from '@angular/material/dialog';
import { CategoryService } from 'src/app/_services/category.service';
import { AppConfig } from 'src/assets/config/config/app-config';
import { FlatTreeControl } from '@angular/cdk/tree';
import { MatTreeFlatDataSource, MatTreeFlattener } from '@angular/material/tree';
import { MigrationService } from 'src/app/_services/document-migration.services';
import { first } from 'rxjs/operators';
import { AlertService } from 'src/app/_services/alert.service';
import { TeamNode } from 'src/app/_models/team';
import { DialogTeamsDeleteConfigComponent } from './dialog-teams-delete-config/dialog-teams-delete-config.component';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { UsersAndGroupsService } from 'src/app/_services/users-and-groups.service';

interface FolderFlatNode {
  expandable: boolean;
  id: number;
  team_name: string;
  parent_id: number;
  level: number;
}

class Stack<T> {
  private items: T[];
  // Private array to store stack elements

  constructor() {
      this.items = [];
      // Initialize the array as empty 
      //when a new stack is created
  }

  // Method to push an 
  // element onto the stack
  push(element: T): void {
      this
          .items.push(element);
  }

  // Method to pop an 
  // element from the stack
  pop(): T | undefined {
      return this
          .items.pop();
  }

  // Method to peek the top element
  // of the stack without removing it
  peek(): T | undefined {
      return this
          .items[this.items.length - 1];
  }

  // Method to check
  // if the stack is empty
  isEmpty(): boolean {
      return this
          .items.length === 0;
  }

  // Method to get 
  // the size of the stack
  size(): number {
      return this
          .items.length;
  }

  // Method to
  // clear the stack
  clear(): void {
      this.items = [];
  }

  // Method to print 
  // the elements of the stack
  print(): void {
      console.log(this.items);
  }
}

@Component({
  selector: 'app-teamfiles',
  templateUrl: './teamfiles.component.html',
  styleUrls: ['./teamfiles.component.scss']
})
export class TeamFilesComponent implements OnInit {

  noDocuments: any;
  checkFolders: any;
  // folders: any;
  navBarFolders: any[];
  filterValue: string;
  url: string;
  folderDetails: any;
  searchCtrl: string = "";
  fetchedGroups: string[] = [];
  allGroups: string[] = [];
  folders = [];
  selectedFolderName: any;
  selectedFolderId: any;
  folderSelected: boolean = false;
  isMainPage: boolean = false;
  isCreateFolder: boolean = false;
  isCreateSubFolder: boolean = false;
  isUpdateFolder: boolean = false;
  currentUser: User;
  documents: any;
  totalDocumentCount: number = 0;
  offset: number = 0;
  selectedDoc: String;
  loadNext: boolean = false;
  loadPrevious: boolean = false;
  documentCount: number = 0;
  documentCols: String[] = [];
  docResultsList: MatTableDataSource<any>;
  selection = new SelectionModel<any>(true, []);
  folderCreated: any;
  fullPath: any;
  //private ithService:ImageTrustService
  width = '100';
  selectedRow: Array<JSON> = [];
  hideDocList: Boolean = false;
  sort;
  iframeUrl = null;
  loading = false;
  displayImageTrust = false;
  allVirtualFolders
  noFolders:boolean = false;
  internalGroupIdentifiers: string[]
  usersList:string[]=[]
  groupList: string[]
  createFormData: FormGroup
  isAdmin:boolean = false;
  isDjango: boolean = false;


  private _transformer = (node: TeamNode, level: number) => {
    return {
      expandable: false,
      id: node.id,
      team_name: node.team_name,
      level: level,
      parent_id: 0,
    };
  };
  treeControl = new FlatTreeControl<FolderFlatNode>(
    (node) => node.level,
    (node) => node.expandable
  );

  treeFlattener = new MatTreeFlattener(
    this._transformer,
    (node) => node.level,
    (node) => node.expandable,
    (node) => node.sub_folders
  );
  virtualFolders = new MatTreeFlatDataSource(
    this.treeControl,
    this.treeFlattener
  );
  hasChild = (_: number, node: FolderFlatNode) => node.expandable;

  constructor(    
    public dialog: MatDialog,
    private authenticationService: AuthenticationService,    
    private migrationService: MigrationService,
    private groupService: UsersAndGroupsService,
    private alertService: AlertService,
    private cdref: ChangeDetectorRef,
    private fb: FormBuilder,  
    private appConfig: AppConfig
  ) {
    this.currentUser = this.authenticationService.currentUserValue;
    this.groupList = this.authenticationService.userGroupsValue;
    this.isAdmin = this.authenticationService.isAdminValue;
    this.isDjango = this.appConfig.getConfig('isDjango')
    this.internalGroupIdentifiers = this.appConfig.getInternalGroupsIdentifier()
    if (!this.authenticationService.isAdminValue) {
      if (this.internalGroupIdentifiers) {
        this.internalGroupIdentifiers.forEach(internalGroupIdentifier => {
          this.groupList.forEach((group) => {
            if (group.includes(internalGroupIdentifier)) {
              this.groupList = this.groupList.filter(obj => obj !== group);
            }
          })
        });
      }
    }
    this.createFormData = this.fb.group({
      team_name: ['', Validators.required],      
      groups: ['']      
    })
  }

  
  ngOnInit(): void {
    this.getTeamsTree();
    if (!this.isAdmin) {
      this.fetchedGroups = this.groupList;
      this.allGroups = this.groupList;
    } else {
      this.groupService.getAllGroups().subscribe(groups => {
        if (this.isDjango) {
          this.fetchedGroups = groups;
          this.allGroups = groups;
          } else {
          this.fetchedGroups = [];
          this.allGroups = [];
          if (groups.Users && groups.Users.length > 0) {
            for (var i = 0; i < groups.Users.length; i++) {
              this.fetchedGroups.push(groups.Users[i].Username);
              this.allGroups.push(groups.Users[i].Username);
            }
          } else {
            this.fetchedGroups = groups;
            this.allGroups = groups;
          }
        }
        console.log(this.fetchedGroups);
      });
    }
  }

  async getFlattenedTeams(){    
    this.allVirtualFolders= await this.migrationService.getTeamsAll();
    this.selectTeam(this.selectedFolderName, this.selectedFolderId);
  }

  private getTeamsTree() {
  this.migrationService
    .getTeamsAll()
    .pipe(first())
    .subscribe((folders) => {
      if(folders.length == 0){
        this.noFolders = true          
      } else {
        this.selectedFolderName = folders[0]['team_name'];
        this.selectedFolderId = folders[0]['id'];          
        this.noFolders = false
        this.virtualFolders.data = folders;
        this.folders = folders;          
        this.navBarFolders = folders;
        this.navBarFolders.sort = this.sort; 
        this.getFlattenedTeams();          
      }
    });
}

applyFilterOnFolders(event: Event) {
  this.filterValue = (event.target as HTMLInputElement).value;
  if (this.filterValue.length > 0) {
    this.navBarFolders = [];
    this.search();
  } else {
    this.virtualFolders.data = this.folders;
  }
}

search() {
  this.folders.filter((form) => {
    if (
      form.team_name
        .trim()
        .toLowerCase()
        .indexOf(this.filterValue.trim().toLowerCase()) > -1
    ) {
      this.navBarFolders.push(form);
    }
    this.navBarFolders = this.navBarFolders.filter((elem, i, arr) => {
      if (arr.indexOf(elem) === i) {
        return elem;
      }
    });
  });
  this.virtualFolders.data = this.navBarFolders;
}

updateFolder(id) {
  this.isUpdateFolder = true;
  this.isMainPage = true;
  this.isCreateFolder = false;
  this.isCreateSubFolder = false;
  this.noDocuments = false;
  let team = undefined;
  if(this.folders && this.folders.length>0) {
    for(let index in this.folders) {
      if(this.folders[index].id == this.selectedFolderId) {
        team = this.folders[index];
        break;
      }
    }
  }
  var data = {
    team_name: team.team_name,      
    groups: team.groups
  }
  this.createFormData.patchValue(data)
}

createFolder() {
  this.isMainPage = true;
  this.isCreateFolder = true;
  this.isCreateSubFolder = false;
  this.isUpdateFolder = false;
  this.folderSelected = false;
  this.createFormData.reset();
}

selectTeam(name, id) {
  this.isMainPage = false;
  this.folderSelected = true;
  this.selectedFolderName = name;
  this.selectedFolderId = id;  
  this.updateFolder(id);
}

deleteFolder() {
  let dialogRef = this.dialog.open(DialogTeamsDeleteConfigComponent,
    { width: '100%', height: "50%", data: { teamName: this.selectedFolderName, teamId: this.selectedFolderId } });
  dialogRef.afterClosed().subscribe(result => {
    if (result == true) {      
      this.alertService.success("Team deleted successfully");
      setTimeout(() => {
        this.getTeamsTree();
      }, 2000);
    } else{
      
    }
  });
}

  refresh() {
    
  }  

  saveUpdateData(formData) {
    formData.id = this.selectedFolderId;    
    this.migrationService.updateTeam(formData).subscribe(resp => {
      this.alertService.success("Team updated successfully");
      setTimeout(() => {
        this.getTeamsTree();
      }, 2000);
    }, error => {
      this.alertService.error("User does not have permission to update the team ");
    })
  }

  saveCreateData(formData) {
    console.log("Create form data", this.createFormData.value['team_name'])
    this.migrationService.createTeam(formData).subscribe(resp => {
      this.folderCreated = true;
      this.alertService.success("Team created successfully");
      setTimeout(() => {
        this.getTeamsTree();
      }, 2000);
    })
  }

  onReturnPage(hide: boolean) {
    if (hide) {
      this.isMainPage = false;
      this.ngOnInit();
      this.isCreateFolder = false;      
      this.isUpdateFolder = false;
    } else {
      this.isMainPage = false;
      this.isCreateFolder = false;      
      this.isUpdateFolder = false;
    }
  }

  alertErrorMessage(message: string){
    this.alertService.error(message);
  }

}
